<template>
  <div class="reporting">
    <b-row class="mb-3">
      <b-col cols="12" md="6">
        <h1 class="mb-0">Rapportering</h1>
      </b-col>
      <b-col class="text-right">
        <b-overlay :show="downloading" variant="light" :opacity="0.75" spinner-variant="secondary" spinner-small rounded="sm" class="d-inline-block ignore-font-size">
          <b-button small @click="downloadReport()">Hent .CSV</b-button>
        </b-overlay>
        <b-button id="popover-selected-fields" variant="primary" class="ml-3">Viste felter</b-button>
      </b-col>
    </b-row>

    <b-popover target="popover-selected-fields" triggers="click blur" placement="bottom">
      <b-form-checkbox-group
        id="selected-fields"
        v-model="selectedFields"
        :options="fieldOptions"
        name="fields"
        size="sm"
        switches
        stacked
      ></b-form-checkbox-group>
    </b-popover>

    <b-alert class="mt-3" style="white-space: break-spaces;" :show="alert !== null" :variant="alertVariant">
      {{alert}}
    </b-alert>

    <b-table
      striped
      hover
      small
      :items="documents"
      :fields="computedFields"
      :busy="loading"
      class="no-wrap mt-3"
      sticky-header="calc(100vh - 210px)"
    >
      <template #table-busy>
        <div style="height: 600px;" class="d-flex justify-content-around align-items-center">
          <b-spinner variant="primary"></b-spinner>
        </div>
      </template>
      <template #cell()="data">
        <template v-if="data.value !== ''">
          {{data.value}}
        </template>
        <template v-else><em class="text-muted">Ingen</em></template>
      </template>
      <template v-slot:cell(10)="item">
        <template v-if="item.unformatted !== ''">
          {{item.unformatted | moment('dddd DD. MMMM, YYYY')}}
        </template>
        <template v-else><em class="text-muted">Ingen</em></template>
      </template>
      <template v-slot:cell(11)="item">
        <template v-if="item.unformatted !== ''">
          {{item.unformatted | moment('dddd DD. MMMM, YYYY')}}
        </template>
        <template v-else><em class="text-muted">Ingen</em></template>
      </template>
      <template v-slot:cell(12)="item">
        <span
          class="font-weight-bold"
          :class="{
            'text-success': item.unformatted,
            'text-danger': !item.unformatted
          }">
          <template v-if="item.unformatted">Ja</template>
          <template v-else>Nej</template>
        </span>
      </template>
      <template v-slot:cell(13)="item">
        <template v-if="item.unformatted !== ''">
          {{item.unformatted | moment('dddd DD. MMMM, YYYY')}}
        </template>
        <template v-else><em class="text-muted">Ingen</em></template>
      </template>
      <template v-slot:cell(14)="item">
        <span
          class="font-weight-bold"
          :class="{
            'text-success': item.unformatted,
            'text-danger': !item.unformatted
          }">
          <template v-if="item.unformatted">Ja</template>
          <template v-else>Nej</template>
        </span>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: 'reporting',
  data: () => ({
    documents: [],
    loading: true,
    downloading: false,
    alert: null,
    alertVariant: 'danger',
    fieldOptions: [
      {text: 'ID', value: '0'},
      {text: 'Journalnr.', value: '1'},
      {text: 'Titel', value: '2'},
      {text: 'Type', value: '3'},
      {text: 'Klassifikation', value: '4'},
      {text: 'Myndighed', value: '5'},
      {text: '1. taksonomibegreb', value: '6'},
      {text: '2. taksonomibegreb', value: '7'},
      {text: '3. taksonomibegreb', value: '8'},
      {text: '4. taksonomibegreb', value: '9'},
      {text: 'Afgørelsesdato', value: '10'},
      {text: 'Udgivelsesdato', value: '11'},
      {text: 'Ophævet', value: '12'},
      {text: 'Ophævelsesdato', value: '13'},
      {text: 'Arkiveret', value: '14'},
    ],
    selectedFields: [
      '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14'
    ],
    fields: [
      {
        key: '0',
        label: 'ID',
        sortable: true
      },
      {
        key: '1',
        label: 'Journalnr.',
        sortable: true
      },
      {
        key: '2',
        label: 'Titel',
        sortable: true
      },
      {
        key: '3',
        label: 'Type',
        sortable: true
      },
      {
        key: '4',
        label: 'Klassifikation',
        sortable: true
      },
      {
        key: '5',
        label: 'Myndighed',
        sortable: true
      },
      {
        key: '6',
        label: '1. taksonomibegreb',
        sortable: true
      },
      {
        key: '7',
        label: '2. taksonomibegreb',
        sortable: true
      },
      {
        key: '8',
        label: '3. taksonomibegreb',
        sortable: true
      },
      {
        key: '9',
        label: '4. taksonomibegreb',
        sortable: true
      },
      {
        key: '10',
        label: 'Afgørelsesdato',
        sortable: true
      },
      {
        key: '11',
        label: 'Udgivelsesdato',
        sortable: true
      },
      {
        key: '12',
        label: 'Ophævet',
        sortable: true
      },
      {
        key: '13',
        label: 'Ophævelsesdato',
        sortable: true
      },
      {
        key: '14',
        label: 'Arkiveret',
        sortable: true
      }
    ]
  }),
  mounted() {
    this.getDocuments()
    this.$emit('setFluid', '')
  },
  beforeDestroy() {
    this.$emit('setFluid', 'md')
  },
  computed: {
    computedFields() {
      return this.fields.filter(field => this.selectedFields.includes(field.key))
    }
  },
  methods: {
    getDocuments() {
      let config = this.$store.getters.getConfig
      this.axios.get('/api/reporting/documents', config).then((response) => {
        let data = response.data.data.documents
        this.documents = data
        this.loading = false
      }).catch(error => {
        this.alert = error
        this.loading = false
      })
    },
    downloadReport() {
      this.downloading = true
      let config = this.$store.getters.getConfig
      this.axios.get('/api/reporting/documents/csv', config).then((response) => {
        let data = response.data
        let csvContent = "data:text/csv;charset=utf-8," + data
        var encodedUri = encodeURI(csvContent)
        var link = document.createElement("a")
        link.setAttribute("href", encodedUri)
        link.setAttribute("download", "dokumenter-" + this.$options.filters.moment(new Date(), 'YYYY-MM-DD') + ".csv")
        document.body.appendChild(link)
        link.click()
        this.loading = false
        document.body.removeChild(link)
        this.downloading = false
      }).catch(error => {
        this.downloading = false
        this.alert = error
        this.loading = false
      })
    }
  }
}
</script>

<style>
.no-wrap th {
  white-space: nowrap;
}
</style>